import DataBus from './databus.js';
//import DisclaimerConfig from './sbconfig.js';
import DCData from './dcdata.js';


// Google Sheets API v4 
//  Pulls the sheet data and then organizes by section
const GoogleSheet =  {
  DISCOVERY_DOCS : ["https://sheets.googleapis.com/$discovery/rest?version=v4"],
  SCOPE : "https://www.googleapis.com/auth/spreadsheets.readonly",

  config : {}, 
  doneCallback : null, 
  userSettingsCallback : null, 

  load: (config, callback, userSettingsCallback) => {
    GoogleSheet.config = config; 
    GoogleSheet.doneCallback = callback; 
    if (userSettingsCallback) {
      GoogleSheet.userSettingsCallback = userSettingsCallback; 
    }
    gapi.load('client:auth2', GoogleSheet.initGapiClient);
  },

  initGapiClient : () => {
    gapi.client.init({
      apiKey: GoogleSheet.config.API_KEY,
      clientId: GoogleSheet.config.CLIENT_ID,
      discoveryDocs: GoogleSheet.DISCOVERY_DOCS,
      scope: GoogleSheet.SCOPE
    }).then(function () {
      GoogleSheet.pullData();
    });
  },

  pullData : () => {
    // get sheet values 
    gapi.client.sheets.spreadsheets.values.get({
      spreadsheetId: GoogleSheet.config.SHEET_ID,
      range: GoogleSheet.config.SHEET_RANGE,
    }).then(function(response) {
      const sheetData = response.result.values;
      //console.log('sheetData', sheetData);
      
      // then get formatted text 
      //    todo: seperate callback for this 
      let formatData = []; 
      if (GoogleSheet.config.DisplayRTF) {
        gapi.client.sheets.spreadsheets.get({
          spreadsheetId: GoogleSheet.config.SHEET_ID,
          ranges: GoogleSheet.config.SHEET_RANGE_RTF,
          includeGridData: true,
        }).then(function (response) {
          formatData = GoogleSheet.parseRTFData(response.result.sheets[0].data[0].rowData); 
          GoogleSheet.parseData(sheetData, formatData);
        });  
      } else {
        GoogleSheet.parseData(sheetData, formatData);
      }
    }); 

    if (GoogleSheet.config.UserSettingsSheet) {
      GoogleSheet.pullUserSettings();
    }
  },

  pullUserSettings : () => {
    // * get user config sheet data 
    gapi.client.sheets.spreadsheets.values.get({
      spreadsheetId: GoogleSheet.config.SHEET_ID,
      range: GoogleSheet.config.USERSETTINGS_SHEET_RANGE,
    }).then(function (response) {
      const userSettingsData = response.result.values;
      //console.log('userSettingsData', userSettingsData);
      const userSettings = {};
      userSettingsData.forEach((row) => {
        userSettings[row[0]] = row[1] ? row[1].toString() : ""; 
      });
      // console.log('GoogleSheet.userSettings', userSettings);
      // DataBus callback  
      GoogleSheet.userSettingsCallback(GoogleSheet.config, userSettings); 
    }); 

  }, 

  // capture rows with rtf data 
  parseRTFData: (data) => {
    const vals = [];
    //console.log(data); 
    data.forEach((row, rowNum) => {
      let cell = (row.values && row.values[0]) ? row.values[0] : null; 
      if (cell && cell.userEnteredValue && cell.textFormatRuns) {
        //console.log(cell); 
        let cellData = {
          rowNum: rowNum,
          text: cell.userEnteredValue.stringValue,
          textFormatRuns: cell.textFormatRuns,
        };
        vals[rowNum] = cellData; 
      }

    });
    //console.log('formattedvals', vals); 
    return vals; 
  },

  // parse sheet data 
  parseData: (data, formatData) => {
    //console.log('data', data); 
    //console.log('formatData', formatData); 
    const regionKeys = GoogleSheet.config.RegionKeys;
    const dataKeys = GoogleSheet.config.DataKeys;

    let dcData = new DCData; 
    
    data.forEach((row, rowNum) => {
      //console.log(row);
      let i = 0; 
      let val = {
        key: row[i],
        rowNum: rowNum,
      };      
      // walk through column values
      regionKeys.forEach((rkey) => {
        i++;
        if (row[i] && row[i]!="") {
          val[rkey.trim()] = true; 
        }
      }); 
      dataKeys.forEach((dkey)=> {
        i++;
        if (row[i] && row[i]!="") {
          val[dkey.trim()] = row[i].trim(); 
        }        
      });
      //console.log(val); 
      // formatted values if available 
      if (formatData[rowNum]) {
        val.formatData = formatData[rowNum];
      }
      // add to dcData  
      if (!dcData[val.section]) {
        dcData[val.section] = [];
      }
      if (val[GoogleSheet.config.LegalColumn]) {
        dcData[val.section].push(val);
      }

    });

    console.log( dcData);
    GoogleSheet.doneCallback(GoogleSheet.config, dcData);
  },


};


export default GoogleSheet;